import { useQuery } from '@tanstack/react-query';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactCampaigns = (contactId?: string) => {
  const queryKey = [contactsEndpoints.campaigns(contactId ?? '')];

  const { data, status, error } = useQuery({
    queryKey,
    queryFn: () => contactsAPI.listCampaigns(contactId!),
    enabled: !!contactId,
  });

  const subscribers = data?.campaigns ?? [];
  const total = data?.pagination?.total ?? subscribers.length;

  return { subscribers, total, status, error };
};
